import { Suspense } from "react";
import SelectLoanType from "app/pages/SelectLoanType";
import PersonalDetails from "app/pages/Individual/PersonalDetails";
import EmploymentDetails from "app/pages/Individual/EmploymentDetails";
import IncomeDetails from "app/pages/Individual/IncomeDetails";
import AssetsLiabilities from "app/pages/Individual/AssetsLiabilities";
import DeclarationSignatures from "app//pages/Individual/DeclarationSignatures";
import JointPersonalDetails from "app/pages/joint/JointPersonalDetails";
import JointEmploymentDetails from "app/pages/joint/JointEmploymentDetails";
import JointIncomeDetails from "app/pages/joint/JointIncomeDetails";
import JointSignatures from "app/pages/joint/JointSignatures";
import JointAssetsliabilities from "app/pages/joint/JointAssetsliabilities";
import Success from "app/pages/Success";

import Welcome from "app/pages/Welcome";
import SignIn from "app/pages/SignIn";
import Otp from "app/pages/Otp";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoutes";

const Protected = (element: JSX.Element) => (
  <ProtectedRoute>{element}</ProtectedRoute>
);

const appRouter = createBrowserRouter([
  {
    path: "/welcome",
    element: <Welcome />,
  },
  {
    path: "/success",
    element: <Success />,
  },
  {
    path: "/sign-in",
    element: <SignIn />,
  },
  {
    path: "/otp/:id",
    element: <Otp />,
  },
  {
    path: "/",
    element: <SelectLoanType />,
  },
  {
    path: "/personal-details",
    element: Protected(<PersonalDetails />),
  },
  {
    path: "/employment-details",
    element: Protected(<EmploymentDetails />),
  },
  {
    path: "/income-details",
    element: Protected(<IncomeDetails />),
  },
  {
    path: "/assets-liabilities",
    element: Protected(<AssetsLiabilities />),
  },
  {
    path: "/signatures",
    element: Protected(<DeclarationSignatures />),
  },
  {
    path: "/joint-personal-details",
    element: Protected(<JointPersonalDetails />),
  },
  {
    path: "/joint-employment-details",
    element: Protected(<JointEmploymentDetails />),
  },
  {
    path: "/joint-income-details",
    element: Protected(<JointIncomeDetails />),
  },
  {
    path: "/joint-assets-liabilities",
    element: Protected(<JointAssetsliabilities />),
  },
  {
    path: "/joint-signatures",
    element: Protected(<JointSignatures />),
  },
]);

const Routes = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <RouterProvider router={appRouter} />
    </Suspense>
  );
};

export default Routes;
